import React from 'react';
import { motion } from 'framer-motion';
import { Gallery } from './Gallery';
import { GoldRule } from './GoldRule';
const fadeUp = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-80px'
  },
  transition: {
    duration: 0.7,
    ease: [0.22, 1, 0.36, 1] as const
  }
};
export function Intro() {
  return <section className="max-w-2xl mx-auto px-6 pt-16" data-id="element-194" data-mp="1sqsu1cnkgj3y">
      <motion.div {...fadeUp} className="relative mb-11 bg-cream p-2 sm:p-3 overflow-hidden" data-id="element-195" data-mp="1srlvpz7o4if8">
        <span aria-hidden className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-serif text-[240px] sm:text-[320px] leading-none text-gold/[0.06] select-none" data-id="element-196" data-mp="1nu2dypbrhnij">G</span>
        <div className="relative border border-gold/40 px-6 py-10 sm:px-12 sm:py-12 text-center" data-id="element-197" data-mp="1xoudvzstgmgh">
          <span aria-hidden className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rotate-45 bg-gold" data-id="element-198" data-mp="19z9rf6xgf72g" />
          <div className="flex items-center justify-center gap-3 mb-5" aria-hidden data-id="element-199" data-mp="14zx6wsu22c31">
            <span className="w-8 sm:w-14 h-px bg-gold-light" data-id="element-200" data-mp="1q3kfpu3c4ed" />
            <span className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-201" data-mp="6oerxtwwy2tf" />
            <span className="w-8 sm:w-14 h-px bg-gold-light" data-id="element-202" data-mp="bg54m6jbp2o0" />
          </div>
          <p className="font-body font-semibold text-[10px] sm:text-[11px] tracking-[4px] sm:tracking-[6px] uppercase text-gold mb-6" data-id="element-203" data-mp="bi9jtkmo9o3l">
            Para ti, mujer extraordinaria
          </p>
          <p className="font-serif font-light text-dark text-[34px] sm:text-[48px] leading-[1.02] tracking-[-1px]" data-id="element-204" data-mp="3eyq2kjolg83a">
            Mereces más
            <br data-id="element-205" data-mp="3nxtqc0yphbo4" />
            <span className="italic text-gold" data-id="element-206" data-mp="3nxaduzrtrfhh">que un salón.</span>
          </p>
          <div className="flex items-center justify-center gap-3 my-6" aria-hidden data-id="element-207" data-mp="3swem9o6xd96r">
            <span className="w-12 sm:w-20 h-px bg-gold-ultra-light" data-id="element-208" data-mp="137coh1ih10gr" />
            <span className="w-1 h-1 rounded-full bg-gold" data-id="element-209" data-mp="13730fjgzl3dp" />
            <span className="w-12 sm:w-20 h-px bg-gold-ultra-light" data-id="element-210" data-mp="185mih8sglv0s" />
          </div>
          <p className="font-serif font-light italic text-mid text-[22px] sm:text-[30px] leading-none" data-id="element-211" data-mp="34911uhk6csj5">
            Mereces una
            <br data-id="element-212" data-mp="30776mosr0gqd" />
            <span className="not-italic text-gold" data-id="element-213" data-mp="307pao7lnjz8u">experiencia.</span>
          </p>
        </div>
      </motion.div>

      <motion.p {...fadeUp} className="font-body font-light text-mid text-sm sm:text-base leading-[1.85] text-center" data-id="element-214" data-mp="3e5njkxh7f3gy">
        Hay salones que te cortan el cabello.
        <br data-id="element-215" data-mp="2ljuhkq3qfsv8" />
        Y hay lugares que{' '}
        <strong className="font-semibold text-dark" data-id="element-216" data-mp="2gjzqomjyj3a6">
          transforman cómo te sientes contigo misma.
        </strong>
        <br data-id="element-217" data-mp="2v9e2s2ex3yt9" />
        Ginger Briones Studio es lo segundo.
      </motion.p>

      {/* PAIN BLOCK */}
      <motion.div {...fadeUp} className="relative my-10 border border-gold/35 border-l-[4px] border-l-gold px-7 py-8 sm:px-9 overflow-hidden bg-[url('https://cdn.magicpatterns.com/patterns/generated-images/b3ba714e-490c-48d3-9920-7b397fa81ab1.jpg')] bg-cover bg-center" data-id="element-218" data-mp="2qhnojlcv0qwk">
        <span aria-hidden className="absolute inset-0 bg-warm-white/80" data-id="element-219" data-mp="dbfvkscvi73l" />
        <span aria-hidden className="absolute top-5 right-6 font-serif text-6xl leading-none text-gold/[0.12] select-none" data-id="element-220" data-mp="da4skur953dj">&ldquo;</span>
        <div className="relative" data-id="element-221" data-mp="4b19hqs34nz1">
          <p className="font-body font-medium text-[10px] tracking-[4px] uppercase text-gold mb-4" data-id="element-222" data-mp="4c2jdrxd74f6">
            Te entendemos
          </p>
          <p className="font-body font-light text-mid text-sm leading-[1.85]" data-id="element-223" data-mp="8a08kur4xqik">
            ¿Cuántas veces saliste de un salón sintiéndote{' '}
            <strong className="font-semibold text-dark" data-id="element-224" data-mp="111a818ta5tnb">decepcionada</strong>? ¿Pagaste más de lo
            que querías por un resultado que no fue lo que pediste? ¿Sentiste que eras solo otro
            turno más en la agenda?
          </p>
          <div className="w-12 h-px bg-gold/60 my-5" aria-hidden data-id="element-225" data-mp="s2ge5q7c3hdg" />
          <p className="font-body font-light text-mid text-sm leading-[1.85]" data-id="element-226" data-mp="37qgicooq8ril">
            Sabemos que tu tiempo es limitado. Tu dinero, valioso. Y tu confianza en un estilista,
            algo que no se da fácilmente.
          </p>
          <p className="font-body font-medium text-dark text-sm leading-[1.85] mt-4" data-id="element-227" data-mp="3s2av9eaj5ed9">
            Eso es exactamente lo que cambia aquí.
          </p>
        </div>
      </motion.div>

      <Gallery data-id="element-228" data-mp="3iay4kq0gwu8t" />

      {/* PROMISE BOX */}
      <motion.div {...fadeUp} className="relative my-10 bg-cream p-2 sm:p-3 overflow-hidden border border-gold-ultra-light" data-id="element-229" data-mp="3e930jdr5k2rc">
        <span aria-hidden className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-serif text-[260px] sm:text-[360px] leading-none text-gold/[0.06] select-none" data-id="element-230" data-mp="esmw7zcbxtyp">
          G
        </span>
        <div className="relative border border-gold/45 px-7 py-11 sm:px-12 sm:py-14 text-center" data-id="element-231" data-mp="5rgexo1uwf4e">
          <span aria-hidden className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rotate-45 bg-gold" data-id="element-232" data-mp="texf7k2wnv1" />
          <div className="flex items-center justify-center gap-3 mb-6" aria-hidden data-id="element-233" data-mp="2qgw0o4m7xdn6">
            <span className="w-10 sm:w-16 h-px bg-gold-light" data-id="element-234" data-mp="2lm8isolpzhhk" />
            <span className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-235" data-mp="113641l6mntpl" />
            <span className="w-10 sm:w-16 h-px bg-gold-light" data-id="element-236" data-mp="160y79bcq3293" />
          </div>
          <p className="font-body font-semibold text-[10px] tracking-[4px] uppercase text-gold mb-6" data-id="element-237" data-mp="15ytt80l40mv3">
            Ginger Briones Studio
          </p>
          <p className="font-serif font-light text-dark text-[30px] sm:text-[40px] leading-[1.15] mb-7" data-id="element-238" data-mp="1eujkurd5idgx">
            Cada visita es
            <br data-id="element-239" data-mp="1jscnxbj5qrcz" />
            <em className="italic text-gold" data-id="element-240" data-mp="1juyv3a24z4uo">una cita contigo misma.</em>
          </p>
          <div className="flex items-center justify-center gap-3 mb-7" aria-hidden data-id="element-241" data-mp="1otsbba8t59yj">
            <span className="w-12 sm:w-20 h-px bg-gold-ultra-light" data-id="element-242" data-mp="1trk3m5dd6y39" />
            <span className="w-1 h-1 rounded-full bg-gold" data-id="element-243" data-mp="1xrcfaqy21kcu" />
            <span className="w-12 sm:w-20 h-px bg-gold-ultra-light" data-id="element-244" data-mp="3vi5bdf63706x" />
          </div>
          <p className="font-body font-light text-mid text-sm leading-[1.9] max-w-md mx-auto" data-id="element-245" data-mp="3vk87mgxu1pk3">
            Un espacio moderno, íntimo y elegante en el corazón de Queens donde Ginger — la dueña —
            te atiende personalmente, escucha lo que quieres y hace que tu visión se convierta en
            realidad. <span className="font-medium text-dark" data-id="element-246" data-mp="11sif267dmghp">Sin prisa. Sin compromiso.</span> Solo resultados que te hacen sentir{' '}
            <em className="font-serif text-lg italic text-gold" data-id="element-247" data-mp="1bntu6pmp5ppz">espectacular</em>.
          </p>
        </div>
      </motion.div>
    </section>;
}